import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

interface Offer {
  id: string;
  title: string;
  description: string;
  center: string;
  originalPrice: number;
  discountedPrice: number;
  discountPercentage: number;
  validUntil: string;
  category: string;
  image: string;
  features: string[];
  terms: string[];
  isPopular?: boolean;
  isLimited?: boolean;
}

const mockOffers: Offer[] = [
  {
    id: '1',
    title: 'فحص شامل للجسم',
    description: 'فحص طبي شامل يشمل جميع التحاليل الأساسية والأشعة التشخيصية',
    center: 'مستشفى الملك فهد',
    originalPrice: 800,
    discountedPrice: 500,
    discountPercentage: 38,
    validUntil: '2024-02-28',
    category: 'فحوصات',
    image: 'https://public.readdy.ai/ai/img_res/ab7d7dcf448977cd71267558d71be830.jpg',
    features: [
      'تحاليل الدم الشاملة',
      'أشعة الصدر',
      'تخطيط القلب',
      'فحص النظر',
      'استشارة طبية'
    ],
    terms: [
      'العرض ساري حتى نهاية الشهر',
      'يجب الحجز مسبقاً',
      'الصيام 12 ساعة قبل الفحص'
    ],
    isPopular: true
  },
  {
    id: '2',
    title: 'جلسات العلاج الطبيعي',
    description: 'باقة 10 جلسات علاج طبيعي مع أفضل المختصين',
    center: 'مجمع عيادات النور الطبي',
    originalPrice: 1200,
    discountedPrice: 800,
    discountPercentage: 33,
    validUntil: '2024-03-15',
    category: 'علاج طبيعي',
    image: 'https://readdy.ai/api/search-image?query=Modern%20physiotherapy%20clinic%20with%20exercise%20equipment%2C%20rehabilitation%20center%2C%20physical%20therapy%20room%2C%20medical%20equipment%20for%20recovery%2C%20clean%20professional%20environment%2C%20therapeutic%20setting&width=300&height=200&seq=2&orientation=landscape',
    features: [
      '10 جلسات علاج طبيعي',
      'تقييم طبي أولي',
      'برنامج تمارين منزلية',
      'متابعة دورية'
    ],
    terms: [
      'صالح لمدة 3 أشهر من تاريخ الحجز',
      'يمكن تحديد مواعيد مرنة',
      'تقييم طبي مطلوب قبل البدء'
    ],
    isLimited: true
  },
  {
    id: '3',
    title: 'فحص الأسنان والتنظيف',
    description: 'فحص شامل للأسنان مع تنظيف احترافي وفلورايد',
    center: 'عيادات الأسنان المتقدمة',
    originalPrice: 400,
    discountedPrice: 250,
    discountPercentage: 38,
    validUntil: '2024-02-20',
    category: 'أسنان',
    image: 'https://readdy.ai/api/search-image?query=Modern%20dental%20clinic%20interior%2C%20dental%20chair%20and%20equipment%2C%20clean%20white%20dental%20office%2C%20professional%20dental%20care%20environment%2C%20dental%20examination%20room%2C%20bright%20medical%20lighting&width=300&height=200&seq=3&orientation=landscape',
    features: [
      'فحص شامل للأسنان',
      'تنظيف احترافي',
      'علاج الفلورايد',
      'استشارة طبية',
      'أشعة بانوراما'
    ],
    terms: [
      'العرض لفترة محدودة',
      'يشمل استشارة مجانية',
      'إمكانية تقسيط العلاج'
    ]
  },
  {
    id: '4',
    title: 'تحاليل الحمل والولادة',
    description: 'باقة شاملة لمتابعة الحمل مع جميع التحاليل المطلوبة',
    center: 'مستشفى النساء والولادة',
    originalPrice: 600,
    discountedPrice: 400,
    discountPercentage: 33,
    validUntil: '2024-03-31',
    category: 'نساء وولادة',
    image: 'https://readdy.ai/api/search-image?query=Modern%20maternity%20clinic%2C%20pregnancy%20care%20center%2C%20obstetrics%20and%20gynecology%20department%2C%20clean%20medical%20environment%2C%20maternal%20healthcare%20setting%2C%20professional%20medical%20facility&width=300&height=200&seq=4&orientation=landscape',
    features: [
      'تحاليل الحمل الأساسية',
      'فحص الموجات فوق الصوتية',
      'استشارة طبية متخصصة',
      'متابعة دورية'
    ],
    terms: [
      'للحوامل في الثلث الأول',
      'يشمل 3 زيارات متابعة',
      'تقرير طبي مفصل'
    ]
  },
  {
    id: '5',
    title: 'فحص العيون الشامل',
    description: 'فحص كامل للعيون مع قياس النظر وفحص قاع العين',
    center: 'مركز العيون المتخصص',
    originalPrice: 300,
    discountedPrice: 180,
    discountPercentage: 40,
    validUntil: '2024-02-25',
    category: 'عيون',
    image: 'https://readdy.ai/api/search-image?query=Modern%20eye%20clinic%20with%20ophthalmology%20equipment%2C%20eye%20examination%20room%2C%20optometry%20center%2C%20professional%20eye%20care%20facility%2C%20clean%20medical%20environment%2C%20vision%20testing%20equipment&width=300&height=200&seq=5&orientation=landscape',
    features: [
      'فحص حدة البصر',
      'قياس ضغط العين',
      'فحص قاع العين',
      'استشارة طبية',
      'وصفة نظارات إذا لزم'
    ],
    terms: [
      'يشمل فحص مجاني للأطفال تحت 12 سنة',
      'خصم إضافي على النظارات',
      'متابعة مجانية لمدة شهر'
    ]
  },
  {
    id: '6',
    title: 'برنامج إنقاص الوزن',
    description: 'برنامج متكامل لإنقاص الوزن مع متابعة طبية ونظام غذائي',
    center: 'مركز التغذية والصحة',
    originalPrice: 1000,
    discountedPrice: 650,
    discountPercentage: 35,
    validUntil: '2024-04-30',
    category: 'تغذية',
    image: 'https://readdy.ai/api/search-image?query=Modern%20nutrition%20clinic%2C%20weight%20loss%20center%2C%20healthy%20lifestyle%20consultation%20room%2C%20dietitian%20office%2C%20clean%20medical%20environment%2C%20wellness%20center%20interior&width=300&height=200&seq=6&orientation=landscape',
    features: [
      'استشارة تغذية متخصصة',
      'برنامج غذائي مخصص',
      'متابعة أسبوعية',
      'قياس تركيب الجسم',
      'برنامج تمارين'
    ],
    terms: [
      'البرنامج لمدة 3 أشهر',
      'متابعة مجانية لمدة شهر إضافي',
      'ضمان النتائج أو استرداد جزئي'
    ],
    isPopular: true
  }
];

export default function OffersPage() {
  const navigate = useNavigate();
  const [offers] = useState<Offer[]>(mockOffers);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(null);

  const categories = [
    { key: 'all', label: 'الكل' },
    { key: 'فحوصات', label: 'فحوصات' },
    { key: 'علاج طبيعي', label: 'علاج طبيعي' },
    { key: 'أسنان', label: 'أسنان' },
    { key: 'نساء وولادة', label: 'نساء وولادة' },
    { key: 'عيون', label: 'عيون' },
    { key: 'تغذية', label: 'تغذية' }
  ];

  const filteredOffers = offers.filter(offer => 
    selectedCategory === 'all' || offer.category === selectedCategory
  );

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('ar-SA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getDaysRemaining = (dateString: string) => {
    const today = new Date();
    const endDate = new Date(dateString);
    const diffTime = endDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  if (selectedOffer) {
    return (
      <div className="min-h-screen bg-gray-50">
        <TopNavigation 
          title="تفاصيل العرض" 
          showBack 
          onBack={() => setSelectedOffer(null)}
        />
        
        <div className="pt-20 pb-24">
          {/* Offer Image */}
          <div className="relative">
            <img
              src={selectedOffer.image}
              alt={selectedOffer.title}
              className="w-full h-64 object-cover"
            />
            <div className="absolute top-4 right-4 flex gap-2">
              {selectedOffer.isPopular && (
                <span className="bg-[#FF3B30] text-white px-2 py-1 rounded-full text-xs font-medium">
                  الأكثر طلباً
                </span>
              )}
              {selectedOffer.isLimited && (
                <span className="bg-[#F9A826] text-white px-2 py-1 rounded-full text-xs font-medium">
                  عرض محدود
                </span>
              )}
              <span className="bg-[#34C759] text-white px-2 py-1 rounded-full text-xs font-medium">
                خصم {selectedOffer.discountPercentage}%
              </span>
            </div>
          </div>

          <div className="px-4">
            {/* Offer Header */}
            <Card padding="md" className="mt-4 mb-4">
              <h1 className="text-xl font-bold text-[#333333] mb-2">{selectedOffer.title}</h1>
              <p className="text-[#7A7A7A] text-sm mb-4">{selectedOffer.description}</p>
              
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-hospital-line text-[#007AFF]"></i>
                <span className="text-[#333333] font-medium">{selectedOffer.center}</span>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold text-[#34C759]">{selectedOffer.discountedPrice} ريال</span>
                    <span className="text-lg text-[#7A7A7A] line-through">{selectedOffer.originalPrice} ريال</span>
                  </div>
                  <p className="text-sm text-[#7A7A7A]">
                    وفر {selectedOffer.originalPrice - selectedOffer.discountedPrice} ريال
                  </p>
                </div>
                <div className="text-left">
                  <p className="text-sm text-[#7A7A7A]">ينتهي في</p>
                  <p className="font-bold text-[#FF3B30]">
                    {getDaysRemaining(selectedOffer.validUntil)} يوم
                  </p>
                </div>
              </div>
            </Card>

            {/* Features */}
            <Card padding="md" className="mb-4">
              <h3 className="font-bold text-[#333333] mb-3">ما يشمله العرض</h3>
              <div className="space-y-2">
                {selectedOffer.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <i className="ri-check-line text-[#34C759] text-sm"></i>
                    <span className="text-[#333333] text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </Card>

            {/* Terms */}
            <Card padding="md" className="mb-6">
              <h3 className="font-bold text-[#333333] mb-3">الشروط والأحكام</h3>
              <div className="space-y-2">
                {selectedOffer.terms.map((term, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <i className="ri-information-line text-[#007AFF] text-sm mt-0.5"></i>
                    <span className="text-[#333333] text-sm">{term}</span>
                  </div>
                ))}
              </div>
            </Card>

            {/* Action Buttons */}
            <div className="space-y-3">
              <Button 
                variant="primary" 
                size="lg" 
                className="w-full"
                onClick={() => navigate('/booking')}
              >
                <i className="ri-calendar-check-line text-lg ml-2"></i>
                احجز الآن
              </Button>
              <div className="grid grid-cols-2 gap-3">
                <Button variant="outline" size="lg">
                  <i className="ri-share-line text-lg ml-1"></i>
                  مشاركة
                </Button>
                <Button variant="outline" size="lg">
                  <i className="ri-heart-line text-lg ml-1"></i>
                  حفظ
                </Button>
              </div>
            </div>
          </div>
        </div>
        
        <BottomNavigation />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation 
        title="العروض والخصومات" 
        showBack 
        onBack={() => navigate('/')}
      />
      
      <div className="pt-20 pb-24 px-4">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-[#333333] mb-2">العروض المتاحة</h1>
          <p className="text-[#7A7A7A] text-sm">اكتشف أفضل العروض والخصومات من شبكة تكافل بلس</p>
        </div>

        {/* Category Filter */}
        <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
          {categories.map((category) => (
            <button
              key={category.key}
              onClick={() => setSelectedCategory(category.key)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                selectedCategory === category.key
                  ? 'bg-[#007AFF] text-white'
                  : 'bg-white text-[#7A7A7A] border border-gray-200'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Offers Grid */}
        <div className="space-y-4">
          {filteredOffers.map((offer) => (
            <Card
              key={offer.id}
              padding="none"
              onClick={() => setSelectedOffer(offer)}
              className="overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
            >
              <div className="relative">
                <img
                  src={offer.image}
                  alt={offer.title}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-3 right-3 flex gap-2">
                  {offer.isPopular && (
                    <span className="bg-[#FF3B30] text-white px-2 py-1 rounded-full text-xs font-medium">
                      الأكثر طلباً
                    </span>
                  )}
                  {offer.isLimited && (
                    <span className="bg-[#F9A826] text-white px-2 py-1 rounded-full text-xs font-medium">
                      عرض محدود
                    </span>
                  )}
                  <span className="bg-[#34C759] text-white px-2 py-1 rounded-full text-xs font-medium">
                    خصم {offer.discountPercentage}%
                  </span>
                </div>
                <div className="absolute bottom-3 left-3">
                  <span className="bg-black/70 text-white px-2 py-1 rounded-full text-xs">
                    ينتهي في {getDaysRemaining(offer.validUntil)} يوم
                  </span>
                </div>
              </div>
              
              <div className="p-4">
                <h3 className="font-bold text-[#333333] mb-2">{offer.title}</h3>
                <p className="text-[#7A7A7A] text-sm mb-3 line-clamp-2">{offer.description}</p>
                
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-hospital-line text-[#007AFF] text-sm"></i>
                  <span className="text-[#333333] text-sm">{offer.center}</span>
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="text-xl font-bold text-[#34C759]">{offer.discountedPrice} ريال</span>
                      <span className="text-sm text-[#7A7A7A] line-through">{offer.originalPrice} ريال</span>
                    </div>
                    <p className="text-xs text-[#7A7A7A]">
                      وفر {offer.originalPrice - offer.discountedPrice} ريال
                    </p>
                  </div>
                  <Button 
                    variant="primary" 
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate('/booking');
                    }}
                  >
                    احجز الآن
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {filteredOffers.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-gift-line text-4xl text-gray-300 mb-4"></i>
            <h3 className="text-lg font-medium text-[#7A7A7A] mb-2">لا توجد عروض</h3>
            <p className="text-sm text-[#7A7A7A]">لم يتم العثور على عروض في هذه الفئة</p>
          </div>
        )}
      </div>
      
      <BottomNavigation />
    </div>
  );
}
